import type { Theme } from '@mui/material/styles';
import type { Components } from '@mui/material/styles/components';

export const MuiOutlinedInput: Components<Theme>['MuiOutlinedInput'] = {
  defaultProps: {
    inputProps: {
      step: 'any',
      min: 0,
      onClick: (e) => e.currentTarget.select(),
    },
  },
  styleOverrides: {
    root: ({ theme }: { theme: Theme }) => ({
      borderRadius: '8px',
      paddingLeft: '6px',
      paddingRight: '6px',
      input: {
        paddingLeft: 0,
        paddingRight: 0,
        '&::placeholder': {
          color: theme.palette.text.disabled,
          lineHeight: theme.typography.body1.lineHeight,
          opacity: 1,
        },
      },
    }),
  },
};
